import React from 'react';
import View from 'src/pages/coming-soon';
import AppRender from 'src/routes/app-render';

const Page = () => {
  return (
    <AppRender>
      <View message={'Các hình đã được thêm vào'} />
    </AppRender>
  );
};

export default Page;